import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { ProjectFilesTreeModule } from "@portal-core/project-files/components/project-files-tree/project-files-tree.module";
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { ProjectChecklistRowsFormComponent } from './project-checklist-rows-form.component';

@NgModule({
  declarations: [
    ProjectChecklistRowsFormComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    FormsModule,
    FormControlErrorMessageModule,
    LoaderModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatTooltipModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    ProjectFilesTreeModule
  ],
  exports: [
    ProjectChecklistRowsFormComponent
  ]
})
export class ProjectChecklistRowsFormModule { }
